import Dropdown from './Dropdown.js';
import Selection from './Selection.js';
import StorageHandler from './StorageHandler.js';
import Results from './Results.js';
import RestAPI from './RestAPI.js';
import Map from './Map/Map.js';

class Main {
    constructor() {
        new StorageHandler;
        new Dropdown;
        new Selection;
        new RestAPI;
        new Results;
        new Map;

        // Clear data from previous run
        // FIXME: We might use this in the future for auto-populating data from previous runs
        StorageHandler.instance.clearData();

        // Trigger initial API call to show unfiltered results
        const event = new CustomEvent('filterDataChanged', {
            bubbles: true
        });

        document.dispatchEvent(event);
    }
}

export default Main;
